import React from 'react';
import {
  MapIcon,
  ClockIcon,
  UserGroupIcon,
} from '@heroicons/react/24/outline';

const reasons = [
  {
    title: 'Nordisk räckvidd',
    description: 'Täcker hela Norden med optimerade rutter och lokalkännedom.',
    icon: MapIcon,
  },
  {
    title: 'Pålitlig leveransprecision',
    description: 'Hög punktlighet med tydliga SLA:er och transparent uppföljning.',
    icon: ClockIcon,
  },
  {
    title: 'Personlig service',
    description: 'Dedikerat team som känner din verksamhet och dina flöden.',
    icon: UserGroupIcon,
  },
];

const WhyUsSection = () => {
  return (
    <section
      aria-labelledby="whyus-title"
      className="bg-gradient-to-b from-white via-white to-slate-50 px-6 py-24 lg:px-8"
    >
      <div className="mx-auto max-w-7xl">
        
        {/* Header */}
        <div className="mx-auto max-w-2xl text-center">
          <h2
            id="whyus-title"
            className="text-xs font-semibold uppercase tracking-[0.2em] text-indigo-700/80"
          >
            Varför Nordic Route?
          </h2>

          <p className="mt-4 text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">
            En logistikpartner du kan bygga på över tid.
          </p>

          <p className="mt-5 text-base leading-7 text-slate-600">
            Vi kombinerar nordisk närvaro med modern teknik och tydlig kommunikation – så att dina
            transporter alltid känns kontrollerade, förutsägbara och professionella.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="mx-auto mt-16 grid max-w-5xl gap-8 sm:grid-cols-3 lg:grid-cols-3">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;

            return (
              <article
                key={reason.title}
                aria-label={`Fördel ${index + 1}: ${reason.title}`}
                className="group relative flex flex-col items-center rounded-2xl border border-slate-200/60 bg-white p-8 text-center shadow-sm transition-all duration-200 hover:shadow-md hover:shadow-indigo-100/50"
              >
                {/* Icon */}
                <div
                  className="mb-6 flex size-14 items-center justify-center rounded-xl bg-indigo-50 ring-1 ring-indigo-100/50 transition-colors group-hover:bg-indigo-100/80"
                  aria-hidden="true"
                >
                  <Icon className="size-7 text-indigo-600" aria-hidden="true" />
                </div>

                {/* Content */}
                <h3 className="text-lg font-semibold text-slate-900">
                  {reason.title}
                </h3>
                <p className="mt-3 text-sm leading-6 text-slate-600">
                  {reason.description}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
